import { useQuery } from "@tanstack/react-query";
import * as React from "react";
import { HelmetDexteel } from "../../../helmet/HelmetDexteel";
import { TableProfiles } from "./components/ProfilesTable/TableProfiles";
import { Profile } from "./models/Profile";
import { getProfiles } from "./repositories/ProfilesRepository";

export const searchProfiles = () => {
	return useQuery<Profile[], Error>({
		queryKey: ["profiles"],
		queryFn: ({ signal }) => getProfiles(signal),
	});
};

export const Profiles = () => {
	return (
		<>
			<HelmetDexteel title="Profile Management" />
			<TableProfiles />
		</>
	);
};
